import * as React from "react";

type LandProps = {
  fillColor?: string;
  height?: string;
  width?: string;
};

const Land = ({ fillColor = "#231815", width = "49.411", height = "36.075" }: LandProps) => {
  return (
    <svg id="land" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 49.411 36.075">
      <path
        id="パス_2298"
        data-name="パス 2298"
        d="M47.911,33.075H39.742V26.953a10.507,10.507,0,0,0,9-10.38C48.742,11.654,44.667,0,38.242,0s-10.5,11.654-10.5,16.573a10.507,10.507,0,0,0,9,10.38v6.122H19.684v-5h4.2a1.5,1.5,0,0,0,1.5-1.5v-9a1.5,1.5,0,0,0-1.5-1.5h-4.2V14.924a1.5,1.5,0,0,0-3,0v1.149h-6V14.924a1.5,1.5,0,0,0-3,0v1.149h-4.2a1.5,1.5,0,0,0-1.5,1.5v9a1.5,1.5,0,0,0,1.5,1.5h4.2v5H1.5a1.5,1.5,0,0,0,0,3H47.911a1.5,1.5,0,0,0,0-3Zm-17.169-16.5C30.742,11.826,34.6,3,38.242,3s7.5,8.827,7.5,13.573a7.513,7.513,0,0,1-6,7.349V16.573a1.5,1.5,0,0,0-3,0v7.349a7.513,7.513,0,0,1-6-7.349Zm-25.757,2.5h17.4v6H4.985v-6Zm5.7,9h6v5h-6v-5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default Land;
